<template>
  <div class="new-landing">
    <bert-loading 
      v-if="isLoading" 
      :fullscreen="true" 
      size="lg" 
      text="Loading BERT Community..."
    />

    <div v-else class="landing-content">
      <AppHeader />

      <section id="beranda" class="hero-section">
        <div class="hero-container">
          <div class="hero-content">
            <h1 class="hero-title">
              Kumpulkan <span class="hero-highlight">Poinnya</span>,<br>
              Dapatkan <span class="hero-highlight">Hadiahnya!</span>
            </h1>
            <bert-button 
              size="lg" 
              variant="primary" 
              class="hero-cta"
              @click="goToRegister"
            >
              Join Sekarang
            </bert-button>
          </div>
          <div class="hero-phones">
            <img src="@/assets/device.png" alt="BERT Points" class="logo-img" />
          </div>
        </div>
      </section>

      <section class="about-section">
        <div class="section-container">
          <div class="about-content">
            <div class="about-icon">
              <div class="bert-icon">
                <img src="@/assets/berts-logo.png" alt="BERT Points" class="logo-img" />
              </div>
            </div>
            <div class="about-text">
              <h2 class="about-title">Apa Itu Bert Points?</h2>
              <p class="about-description">
                Bert Points adalah Program Rewards dari BERT's Community untuk 
                mengapresiasi keaktifan member dalam kegiatan komunitas.
                Di sini, para anggota komunitas dapat membangun network, 
                mengikuti beragam event brand, dan mendapatkan produk gratis!
              </p>
            </div>
          </div>
        </div>
      </section>

      <section id="komunitas" class="communities-section">
        <div class="communities-container">
          <div class="communities-content">
            <div class="communities-title-section">
              <h2 class="section-title">Komunitas Kami</h2>
            </div>
            
            <div class="communities-logos">
              <div class="community-logo-item">
                <img src="@/assets/ibu-canggih.png" alt="Ibu2Canggih" class="community-logo-img" />
              </div>
              <div class="community-logo-item">
                <img src="@/assets/geng-glowing.png" alt="Geng Glowing" class="community-logo-img" />
              </div>
              <div class="community-logo-item">
                <img src="@/assets/ikan-galau.png" alt="Ikan Galau" class="community-logo-img" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="benefit" class="benefits-section">
        <div class="section-container">
          <div class="section-header">
            <h2 class="section-title">Manfaat Bergabung dengan Kami</h2>
          </div>
          
          <div class="benefits-content">
            <div class="benefits-image">
              <div class="benefit-image-frame">
                <img src="@/assets/community-photo.png" alt="Community Members" class="benefit-photo" />
              </div>
            </div>
            
            <div class="benefits-grid">
              <div class="benefit-item">
                <div class="benefit-icon">
                  <img src="@/assets/benefit-logo-1.svg" class="benefit-logo" />
                </div>
                <div class="benefit-text">
                  <h3>Membangun network dengan member lain</h3>
                </div>
              </div>
              
              <div class="benefit-item">
                <div class="benefit-icon">
                  <img src="@/assets/benefit-logo-2.svg" class="benefit-logo" />
                </div>
                <div class="benefit-text">
                  <h3>Memiliki kesempatan menjadi BERT's Influencers</h3>
                </div>
              </div>
              
              <div class="benefit-item">
                <div class="benefit-icon">
                  <img src="@/assets/benefit-logo-3.svg" class="benefit-logo" />
                </div>
                <div class="benefit-text">
                  <h3>Mengikuti beragam event brands dan komunitas</h3>
                </div>
              </div>
              
              <div class="benefit-item">
                <div class="benefit-icon">
                  <img src="@/assets/benefit-logo-4.svg" class="benefit-logo" />
                </div>
                <div class="benefit-text">
                  <h3>Mendapatkan produk gratis dan eksklusif dari brands</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="how-to-section">
        <div class="section-container">
          <div class="how-to-content">
            <!-- Dynamic Image Display -->
            <div class="mockup-container">
              <transition name="fade" mode="out-in">
                <img 
                  :key="activeStep" 
                  :src="getCurrentMockupImage()" 
                  :alt="`Step ${activeStep} mockup`"
                  class="mockup-image"
                />
              </transition>
            </div>
            
            <div class="how-to-text">
              <h2 class="how-to-title">Cara Mengumpulkan<br>Bert Points</h2>
              
              <div class="steps-list">
                <div 
                  class="step-item"
                  :class="{ 'step-item-active': activeStep === 1 }"
                  @click="setActiveStep(1)"
                >
                  <div 
                    class="step-number"
                    :class="{ 'step-number-active': activeStep === 1 }"
                  >
                    1
                  </div>
                  <div class="step-text">
                    Daftar, pilih komunitas, dan lengkapi profil data Anda
                  </div>
                </div>
                
                <div 
                  class="step-item"
                  :class="{ 'step-item-active': activeStep === 2 }"
                  @click="setActiveStep(2)"
                >
                  <div 
                    class="step-number"
                    :class="{ 'step-number-active': activeStep === 2 }"
                  >
                    2
                  </div>
                  <div class="step-text">
                    Ikuti beragam aktivitas untuk mendapatkan Bert Points
                  </div>
                </div>
                
                <div 
                  class="step-item"
                  :class="{ 'step-item-active': activeStep === 3 }"
                  @click="setActiveStep(3)"
                >
                  <div 
                    class="step-number"
                    :class="{ 'step-number-active': activeStep === 3 }"
                  >
                    3
                  </div>
                  <div class="step-text">
                    Tukarkan Bert Points dengan beragam hadiah dari brand
                  </div>
                </div>
              </div>
              <div class="learn-more-btn">
                <bert-button variant="ghost" @click="goToBenefitBertPoints">
                  Cari Tahu Lebih Lanjut →
                </bert-button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="sponsors-section">
        <div class="section-container">
          <div class="section-header">
            <h2 class="section-title">Sponsor Hadiah Bert Points</h2>
          </div>
          
          <sponsor-carousel 
            :autoplayTimeout="3000"
            :sponsors="sponsorBanners"
          />
        </div>
      </section>

      <section class="brand-partner-cta">
        <div class="cta-container">
          <div class="cta-content">
            <h2 class="cta-title">Ingin Menjadi Brand Partner Kami?</h2>
          </div>
          <div class="cta-action">
            <bert-button variant="outline" @click="contactUs('Halo Admin, saya berminat untuk daftar jadi Brand Partner. Bagaimana caranya?')">
              Klik Disini!
            </bert-button>
          </div>
        </div>
      </section>

      <section class="testimonials-section">
        <div class="section-container">
          <div class="testimonials-header">
            <h2 class="testimonials-title">
              BERT's Community<br>
              Sudah Memiliki 15.000+ Members!
            </h2>
            <div class="testimonials-nav desktop-nav">
              <button class="nav-btn prev" @click="prevTestimonial">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polyline points="15,18 9,12 15,6"></polyline>
                </svg>
              </button>
              <button class="nav-btn next" @click="nextTestimonial">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polyline points="9,18 15,12 9,6"></polyline>
                </svg>
              </button>
            </div>
          </div>
          
          <div class="testimonials-grid">
            <bert-card 
              v-for="testimonial in visibleTestimonials" 
              :key="testimonial.id"
              variant="default"
              class="testimonial-card"
            >
              <div class="testimonial-header">
                <div class="testimonial-avatar">
                  <img :src="testimonial.avatar" :alt="testimonial.name" />
                </div>
                <div class="testimonial-info">
                  <h4 class="testimonial-name">{{ testimonial.name }}</h4>
                  <p class="testimonial-role">{{ testimonial.role }}</p>
                </div>
              </div>
              <p class="testimonial-text">{{ testimonial.text }}</p>
            </bert-card>
          </div>
          
          <div class="testimonials-nav mobile-nav">
            <button class="nav-btn prev" @click="prevTestimonial">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="15,18 9,12 15,6"></polyline>
              </svg>
            </button>
            <button class="nav-btn next" @click="nextTestimonial">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="9,18 15,12 9,6"></polyline>
              </svg>
            </button>
          </div>
        </div>
      </section>

      <section class="social-section">
        <div class="section-container">
          <div class="social-header">
            <h2 class="social-title">Jangan Lewatkan Kabar Terbaru!</h2>
            <p class="social-subtitle">Ikuti dan dapatkan kabar terupdate dari komunitas kami</p>
          </div>
          
          <div class="social-grid">
            <bert-card variant="default" class="social-card">
              <div class="social-icons">
                <div class="social-icon instagram">
                  <a href="https://www.instagram.com/ibu2canggih" target="_blank" class="social-icon instagram">
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                    </svg>
                  </a>
                </div>
                <div class="social-icon tiktok">
                  <a href="https://www.tiktok.com/@ibu2canggih" target="_blank" class="social-icon tiktok">
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
                    </svg>
                  </a>
                </div>
              </div>
              <h3 class="social-handle">@ibu2canggih</h3>
              <p class="social-desc">
                Komunitas para ibu modern & serba bisa 
                untuk saling belajar, berdaya, dan 
                bertumbuh bersama.
              </p>
            </bert-card>
            
            <bert-card variant="default" class="social-card">
              <div class="social-icons">
                <div class="social-icon instagram">
                  <a href="https://www.instagram.com/geng.glowing" target="_blank" class="social-icon instagram">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                    </svg>
                  </a>
                </div>
                <div class="social-icon tiktok">
                  <a href="https://www.tiktok.com/@geng.glowing" target="_blank" class="social-icon tiktok">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
                    </svg>
                  </a>
                </div>
              </div>
              <h3 class="social-handle">@Geng.glowing</h3>
              <p class="social-desc">
                Komunitas yang fokus memberikan tips, 
                ulasan, dan edukasi mengenai kesehatan 
                kulit dan kecantikan.
              </p>
            </bert-card>
            
            <bert-card variant="default" class="social-card">
              <div class="social-icons">
                <div class="social-icon instagram">
                  <a href="https://www.instagram.com/ikan.galau" target="_blank" class="social-icon instagram">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                    </svg>
                  </a>
                </div>
                <div class="social-icon tiktok">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
                  </svg>
                </div>
              </div>
              <h3 class="social-handle">@ikan.galau</h3>
              <p class="social-desc">
                Talent agency di mana Creators-nya 
                dikembangkan menjadi komunitas untuk 
                sharing dan berkolaborasi dengan brands.
              </p>
            </bert-card>
          </div>
        </div>
      </section>
      <!-- Further Development -->
     <!-- <section class="merchandise-section">
        <div class="section-container">
          <div class="section-header">
            <div class="merchandise-header-content">
              <div class="merchandise-title-section">
                <h2 class="section-title">Merchandise Bert Points</h2>
                <p class="section-subtitle">Kumpulkan Poinnya, Koleksi Merchnya!</p>
              </div>
            </div>
          </div>
          
          <div class="merchandise-wrapper">
            
            <button class="carousel-btn prev-floating" @click="prevMerchandise">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="15,18 9,12 15,6"></polyline>
              </svg>
            </button>

            <div class="merchandise-slider-container">
              <div 
                class="merchandise-slider" 
                :style="{ 
                  transform: `translateX(${merchandiseTransform}px)`,
                  transition: `transform ${transitionDuration}s ease` 
                }"
              >
                <div 
                  v-for="item in merchandiseItems" 
                  :key="`first-${item.id}`"
                  class="merchandise-item"
                >
                  <div class="merchandise-card">
                    <div class="merchandise-image">
                      <div class="merchandise-placeholder">
                        <svg width="200" height="200" viewBox="0 0 200 200" fill="none">
                          <rect width="200" height="200" rx="8" fill="#E5E7EB"/>
                          <circle cx="100" cy="80" r="20" fill="#9CA3AF"/>
                          <rect x="60" y="120" width="80" height="8" rx="4" fill="#9CA3AF"/>
                          <rect x="70" y="140" width="60" height="6" rx="3" fill="#D1D5DB"/>
                        </svg>
                      </div>
                    </div>
                    <div class="merchandise-info">
                      <h4 class="merchandise-name">{{ item.name }}</h4>
                      <p class="merchandise-points">{{ item.points }} Points</p>
                    </div>
                  </div>
                </div>
                <div 
                  v-for="item in merchandiseItems" 
                  :key="`second-${item.id}`"
                  class="merchandise-item"
                >
                  <div class="merchandise-card">
                    <div class="merchandise-image">
                      <div class="merchandise-placeholder">
                        <svg width="200" height="200" viewBox="0 0 200 200" fill="none">
                          <rect width="200" height="200" rx="8" fill="#E5E7EB"/>
                          <circle cx="100" cy="80" r="20" fill="#9CA3AF"/>
                          <rect x="60" y="120" width="80" height="8" rx="4" fill="#9CA3AF"/>
                          <rect x="70" y="140" width="60" height="6" rx="3" fill="#D1D5DB"/>
                        </svg>
                      </div>
                    </div>
                    <div class="merchandise-info">
                      <h4 class="merchandise-name">{{ item.name }}</h4>
                      <p class="merchandise-points">{{ item.points }} Points</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <button class="carousel-btn next-floating" @click="nextMerchandise">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="9,18 15,12 9,6"></polyline>
              </svg>
            </button>

          </div>
        </div>
      </section> -->

      <AppFooter />
    </div>
  </div>
</template>

<script>
import BertButton from './ui/Button.vue'
import BertCard from './ui/Card.vue'
import BertLoading from './ui/Loading.vue'
import SponsorCarousel from './ui/SponsorCarousel.vue'
import Header from './layout/Header.vue'
import Footer from './layout/Footer.vue'

export default {
  name: 'NewLandingPage',
  components: {
    BertButton,
    BertCard,
    BertLoading,
    SponsorCarousel,
    AppHeader: Header,
    AppFooter: Footer
  },
  data() {
    return {
      isLoading: false,
      currentTestimonial: 0,
      activeStep: 1, // Active step for how-to section
      sponsorBanners: [], // Add sponsor banners data
      
      // Merchandise Carousel State
      merchandiseTranslateX: 0,
      merchandiseItemWidth: 0,
      merchandiseIndex: 0,
      transitionDuration: 0.3,
      isAnimating: false,
      
      isMobile: false,
      merchandiseItems: [
        {
          id: 1,
          name: 'BERT T-Shirt',
          image: '@/assets/merch-tshirt.png',
          points: 500
        },
        {
          id: 2,
          name: 'BERT Tote Bag',
          image: '@/assets/merch-totebag.png',
          points: 300
        },
        {
          id: 3,
          name: 'BERT Mug',
          image: '@/assets/merch-mug.png',
          points: 250
        },
        {
          id: 4,
          name: 'BERT Sticker Pack',
          image: '@/assets/merch-stickers.png',
          points: 100
        },
        {
          id: 5,
          name: 'BERT Notebook',
          image: '@/assets/merch-notebook.png',
          points: 200
        },
        {
          id: 6,
          name: 'BERT Cap',
          image: '@/assets/merch-cap.png',
          points: 400
        }
      ],
      testimonials: [
        {
          id: 1,
          name: 'Della Jullyanti',
          role: 'Member Ibu2Canggih',
          avatar: require('@/assets/testi1.svg'),
          text: 'Sejak menjadi member Bert Points, aku jadi semakin kreatif dalam membuat video konten. Meskipun aku seorang ibu rumah tangga, aku tetap bisa produktif dari rumah, senang deh!'
        },
        {
          id: 2,
          name: 'Bangun Ambar Ekowati',
          role: 'Bert Influencer',
          avatar: require('@/assets/testi-2.jpg'),
          text: 'Enaknya gabung di Bertpoints tuh, kita bisa dapetin produk dari hasil ngumpulin poin dan poinnya bisa dituker jadi produk gratis. Yang paling aku suka, produk yang didapet beneran kepake banget buat aku. Terima kasih Bertpoints.'
        },
        {
          id: 3,
          name: 'Ria Pratiwi',
          role: 'Bert Influencer',
          avatar: require('@/assets/testi3.svg'),
          text: 'Bergabung Bert Points bisa kerja dari rumah sambil mengurus anak. Kegiatannya seru-seru dan banyak insight, dan pastinya mendapat reward!'
        }
      ]
    }
  },
  computed: {
    visibleTestimonials() {
      const count = this.isMobile ? 1 : 3
      
      const testimonials = []
      for (let i = 0; i < count; i++) {
        const index = (this.currentTestimonial + i) % this.testimonials.length
        testimonials.push(this.testimonials[index])
      }
      return testimonials
    },
    merchandiseTransform() {
      return this.merchandiseTranslateX
    }
  },
  methods: {
    checkScreenSize() {
      this.isMobile = window.innerWidth <= 768
      this.calculateMerchandiseItemWidth()
    },
    calculateMerchandiseItemWidth() {
      this.$nextTick(() => {
        const container = this.$el?.querySelector('.merchandise-slider-container')
        if (container) {
          const containerWidth = container.offsetWidth
          this.merchandiseItemWidth = this.isMobile ? containerWidth : containerWidth / 3
        }
      })
    },
    goToLogin() {
      this.$router.push('/login')
    },
    goToRegister() {
      this.$router.push('/registrasi')
    },
    goToBenefitBertPoints() {
      this.$router.push('/benefit')
    },
    setActiveStep(step) {
      this.activeStep = step
    },
    getCurrentMockupImage() {
      switch(this.activeStep) {
        case 1:
          return require('@/assets/phone-regis.png')
        case 2:
          return require('@/assets/event-mockup.png')
        case 3:
          return require('@/assets/point-mockup.png')
        default:
          return require('@/assets/phone-regis.png')
      }
    },
    prevTestimonial() {
      this.currentTestimonial = this.currentTestimonial === 0 
        ? this.testimonials.length - 1 
        : this.currentTestimonial - 1
    },
    nextTestimonial() {
      this.currentTestimonial = (this.currentTestimonial + 1) % this.testimonials.length
    },
    contactUs(message) {
      const phoneNumber = "628115674433"; 
      const url = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`;
      window.location.href = url;
    },
    loadSponsorBanners() {
      if (!this.$http || !this.$settings) {
        console.warn('HTTP client or settings not available, using static sponsors');
        this.sponsorBanners = this.getStaticSponsors();
        return Promise.resolve();
      }
      
      const baseURI = this.$settings.endPoint + "get-banner";
      return this.$http
        .get(
          baseURI +
          `?limit=10&page=1&sort_field=&sort_type=&title=&link=&priority=&location=sponsor`,
          {
            timeout: 10000,
            'headers': {
              'AppToken': this.$settings.jwtSecret,
            }
          }
        )
        .then((response) => {
          this.sponsorBanners = response.data.datas || [];
          
          if (this.sponsorBanners.length === 0) {
            this.sponsorBanners = this.getStaticSponsors();
          }
        }).catch(error => {
          console.log('Error loading sponsor banners:', error);
          this.sponsorBanners = this.getStaticSponsors();
        });
    },
    getStaticSponsors() {
      return [
        { 
          id: 1, 
          title: 'Isntree', 
          image: require('@/assets/isntree.svg'),
          link: '#'
        },
        { 
          id: 2, 
          title: 'Laneige', 
          image: require('@/assets/laneige.svg'),
          link: '#'
        },
        { 
          id: 3, 
          title: 'Aestura', 
          image: require('@/assets/aestura.svg'),
          link: '#'
        },
        { 
          id: 4, 
          title: 'Isntree', 
          image: require('@/assets/isntree.svg'),
          link: '#'
        },
        { 
          id: 5, 
          title: 'Laneige', 
          image: require('@/assets/laneige.svg'),
          link: '#'
        },
        { 
          id: 6, 
          title: 'Aestura', 
          image: require('@/assets/aestura.svg'),
          link: '#'
        }
      ];
    },
    
    // --- Seamless Infinite Carousel Logic ---
    nextMerchandise() {
      if (this.isAnimating) return
      this.isAnimating = true

      const itemsToMove = 1
      this.merchandiseIndex += itemsToMove
      this.merchandiseTranslateX -= this.merchandiseItemWidth * itemsToMove

      if (this.merchandiseIndex >= this.merchandiseItems.length) {
        setTimeout(() => {
          this.transitionDuration = 0
          
          this.merchandiseIndex = 0
          this.merchandiseTranslateX = 0

          setTimeout(() => {
            this.transitionDuration = 0.3
            this.isAnimating = false
          }, 50)
        }, 300)
      } else {
        setTimeout(() => {
          this.isAnimating = false
        }, 300)
      }
    },
    prevMerchandise() {
      if (this.isAnimating) return
      this.isAnimating = true

      // If at start, snap to the end of duplicate set first
      if (this.merchandiseIndex <= 0) {
        this.transitionDuration = 0
        this.merchandiseIndex = this.merchandiseItems.length
        this.merchandiseTranslateX = -this.merchandiseItemWidth * this.merchandiseItems.length

        setTimeout(() => {
          this.transitionDuration = 0.3
          
          this.merchandiseIndex -= 1
          this.merchandiseTranslateX += this.merchandiseItemWidth
          
          setTimeout(() => {
            this.isAnimating = false
          }, 300)
        }, 50)
      } else {
        this.merchandiseIndex -= 1
        this.merchandiseTranslateX += this.merchandiseItemWidth
        setTimeout(() => {
          this.isAnimating = false
        }, 300)
      }
    },
    // ----------------------------------------

    loading() {
      this.isLoading = true
      setTimeout(() => {
        this.isLoading = false
        // Recalculate width after loading
        this.$nextTick(() => {
          this.calculateMerchandiseItemWidth()
        })
      }, 1500)
    }
  },
  mounted() {
    this.loading()
    this.loadSponsorBanners()
    this.checkScreenSize()
    window.addEventListener('resize', this.checkScreenSize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize)
  }
}
</script>

<style scoped>
.new-landing {
  min-height: 100vh;
  background: #F5F5F5;
}

.landing-content {
  width: 100%;
}

/* Header Navigation */
.header-nav {
  background: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 100;
}

.nav-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 var(--space-6);
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 80px;
}

.nav-logo .logo-img {
  height: 40px;
  width: auto;
}

.nav-menu {
  display: flex;
  gap: var(--space-8);
}

.nav-link {
  text-decoration: none;
  color: var(--neutral-700);
  font-weight: var(--font-medium);
  font-size: var(--text-base);
  transition: color var(--transition-base);
  border-bottom: 2px solid transparent;
  padding-bottom: 4px;
}

.nav-link:hover {
  color: var(--yellow-main);
  border-bottom-color: var(--yellow-main);
}

/* Hero Section */
.hero-section {
  padding: var(--space-20) 0;
  background: white;
}

.hero-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 var(--space-6);
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--space-16);
  align-items: center;
}

.hero-content {
  display: flex;
  flex-direction: column;
  gap: var(--space-8);
  text-align: center;
}

.hero-title {
  font-size: 3.5rem;
  font-weight: var(--font-bold);
  line-height: 1.2;
  margin: 0;
  color: var(--text-dark);
}

.hero-highlight {
  color: var(--yellow-main);
}

.hero-cta {
  align-self: center;
  padding: var(--space-4) var(--space-8);
  font-size: var(--text-lg);
  background: var(--yellow-main);
  border: none;
  border-radius: 25px;
}

/* Phone Mockups */
.hero-phones {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: var(--space-4);
  position: relative;
  max-width: 100%;
  overflow: hidden;
}

.hero-phones .logo-img {
  max-width: 100%;
  height: auto;
  object-fit: contain;
}

.phone-mockup {
  width: 180px;
  height: 360px;
  background: #1F2937;
  border-radius: 25px;
  padding: 8px;
  position: relative;
}

.phone-center {
  transform: scale(1.1);
  z-index: 2;
}

.phone-left,
.phone-right {
  transform: scale(0.9);
  opacity: 0.8;
}

.phone-screen {
  width: 100%;
  height: 100%;
  background: white;
  border-radius: 20px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.phone-content {
  padding: var(--space-4);
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.phone-content.orange-theme {
  background: linear-gradient(135deg, var(--yellow-main) 0%, var(--yellow-soft) 100%);
  color: white;
}

.phone-header {
  font-size: var(--text-lg);
  font-weight: var(--font-bold);
  text-align: center;
}

.phone-points {
  display: flex;
  justify-content: space-around;
  margin: var(--space-4) 0;
}

.point-item {
  background: rgba(255, 255, 255, 0.2);
  padding: var(--space-2) var(--space-3);
  border-radius: var(--radius-lg);
  font-size: var(--text-sm);
}

.phone-buttons {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.phone-btn {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  padding: var(--space-2);
  border-radius: var(--radius-md);
  color: white;
  font-size: var(--text-sm);
}

/* About Section */
.about-section {
  padding-bottom: var(--space-20);
  background: white;
}

.about-content {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: var(--space-12);
  align-items: center;
  max-width: 1000px;
  margin: 0 auto;
  padding: 0 var(--space-6);
}

.about-title {
  font-size: var(--text-5xl);
  font-weight: 700;
  color: #292D32;
  margin: 0 0 var(--space-6) 0;
}

.about-description {
  font-size: var(--text-lg);
  line-height: 1.6;
  color: var(--neutral-600);
  margin: 0;
}

/* Communities Section */
.communities-section {
  padding: var(--space-16) 0;
  background: #F1F9FF;
}

.communities-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 var(--space-6);
}

.communities-content {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  gap: var(--space-12);
}

.communities-title-section {
  flex-shrink: 0;
}

.communities-title-section .section-title {
  font-size: var(--text-5xl);
  font-weight: var(--font-bold);
  color: var(--text-dark);
  margin: 0;
  text-align: left;
}

.communities-logos {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: var(--space-8);
  flex-direction: row;
}

.community-logo-item {
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  padding: var(--space-4) var(--space-6);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
  transition: all var(--transition-base);
  min-width: 140px;
  min-height: 80px;
}

.community-logo-item:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.community-logo-img {
  height: 60px;
  width: auto;
  max-width: 150px;
  object-fit: contain;
}

/* Benefits Section */
.benefits-section {
  padding: var(--space-20) 0;
  background: white;
}

.benefits-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--space-16);
  align-items: start;
}

.benefits-image {
  display: flex;
  justify-content: center;
}

.benefit-image-frame {
  border: 4px solid #228CDB;
  border-radius: var(--radius-2xl);
  padding: var(--space-4);
  background: #F1F9FF;
  max-width: 400px;
}

.benefit-photo {
  width: 100%;
  height: auto;
  border-radius: var(--radius-lg);
  display: block;
}

.benefits-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2.7rem;
}

.benefit-item {
  display: flex;
  flex-direction: column;
  align-items: start;
  text-align: start;
  gap: var(--space-4);
  background: #F1F9FF;
  padding: 24px;
  border-radius: 12px;
}

.benefit-logo {
  width: 90%;
}

.benefit-text h3 {
  font-size: var(--text-base);
  font-weight: var(--font-medium);
  color: var(--text-dark-grey);
  margin: 0;
  line-height: 1.4;
}

/* How To Section */
.how-to-section {
  padding: var(--space-20) 0;
  background: #F5F5F5;
}

.how-to-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--space-16);
  align-items: center;
}

.mockup-container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.mockup-image {
  max-width: 100%;
  height: auto;
  object-fit: contain;
  transition: all 0.3s ease;
}

/* Fade Animation for Image Transitions */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.fade-enter {
  opacity: 0;
  transform: translateY(10px);
}

.fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.phone-mockup-large {
  width: 300px;
  height: 600px;
  background: #1F2937;
  border-radius: 30px;
  padding: 12px;
  margin: 0 auto;
}

.phone-screen-large {
  width: 100%;
  height: 100%;
  background: white;
  border-radius: 25px;
  overflow: hidden;
  padding: var(--space-6);
}

.registration-form h3 {
  text-align: center;
  margin-bottom: var(--space-6);
  color: var(--neutral-800);
}

.form-field {
  margin-bottom: var(--space-4);
}

.form-field label {
  display: block;
  font-size: var(--text-sm);
  font-weight: var(--font-medium);
  color: var(--neutral-700);
  margin-bottom: var(--space-2);
}

.form-field input,
.form-field select {
  width: 100%;
  padding: var(--space-2);
  border: 1px solid var(--neutral-300);
  border-radius: var(--radius-md);
  font-size: var(--text-sm);
}

.how-to-title {
  font-size: var(--text-5xl);
  font-weight: var(--font-bold);
  color: var(--neutral-800);
  margin: 0 0 var(--space-8) 0;
  line-height: 1.2;
}

.steps-list {
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
  margin-bottom: var(--space-8);
}

.step-item-active {
  display: flex;
  gap: var(--space-4);
  align-items: flex-start;
  padding: 20px 24px;
  border: 2px solid #F9A619;
  background: #FFBD4D;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  transform: scale(1.02);
  box-shadow: 0 4px 12px rgba(249, 166, 25, 0.3);
}

.step-item {
  display: flex;
  gap: var(--space-4);
  align-items: flex-start;
  padding: 20px 24px;
  border: 1px solid #E4E4E4;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.step-item:hover {
  border-color: #F9A619;
  background: #FFF8E7;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.step-number-active {
  width: 32px;
  height: 32px;
  background: var(--yellow-main);
  color: black;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: var(--font-bold);
  flex-shrink: 0;
  transition: all 0.3s ease;
}

.step-number {
  width: 32px;
  height: 32px;
  border: 1px solid #E4E4E4;
  color: black;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: var(--font-bold);
  flex-shrink: 0;
  background: white;
  transition: all 0.3s ease;
}

.step-item:hover .step-number {
  border-color: #F9A619;
  background: #FFF8E7;
}

.step-text {
  font-size: var(--text-base);
  line-height: 1.5;
  color: #2B2F3C;
  align-self: center;
}

.learn-more-btn {
  text-align: end;
}

/* Sponsors Section */
.sponsors-section {
  padding: var(--space-16) 0;
  background: var(--blue-medium);
  color: white;
}

.sponsors-section .section-title {
  color: white;
  text-align: center;
  margin-bottom: var(--space-8);
}

/* Brand Partner CTA */
.brand-partner-cta {
  background: linear-gradient(135deg, var(--yellow-main) 0%, var(--yellow-soft) 100%);
  padding: var(--space-8) 0;
}

.cta-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 var(--space-6);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.cta-title {
  font-size: var(--text-3xl);
  font-weight: var(--font-bold);
  color: white;
  margin: 0;
}

/* Testimonials Section */
.testimonials-section {
  padding: var(--space-20) 0;
  background: white;
}

.testimonials-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: var(--space-12);
}

.testimonials-title {
  font-size: var(--text-5xl);
  font-weight: var(--font-bold);
  color: var(--neutral-800);
  margin: 0;
  line-height: 1.2;
}

.testimonials-nav {
  display: flex;
  gap: var(--space-3);
}

.mobile-nav {
  display: none;
}

.desktop-nav {
  display: flex;
}

.nav-btn {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 2px solid var(--neutral-300);
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all var(--transition-base);
}

.nav-btn:hover {
  background: var(--yellow-main);
  border-color: var(--yellow-main);
  color: white;
}

.nav-btn.next:hover {
  background: var(--yellow-main);
  border-color: var(--yellow-main);
  color: white;
}

.testimonials-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: var(--space-6);
}

.testimonial-card {
  padding: var(--space-3);
}

.testimonial-header {
  display: flex;
  gap: var(--space-4);
  margin-bottom: var(--space-4);
}

.testimonial-avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  overflow: hidden;
}

.testimonial-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.testimonial-name {
  font-size: var(--text-lg);
  font-weight: var(--font-semibold);
  color: var(--neutral-800);
  margin: 0;
}

.testimonial-role {
  font-size: var(--text-sm);
  color: var(--neutral-500);
  margin: 0;
}

.testimonial-text {
  font-size: var(--text-sm);
  line-height: 1.5;
  color: var(--neutral-600);
  margin: 0;
}

/* Social Section Styles */
.social-section {
  padding: var(--space-20) 0;
  background: #4A90E2; 
  color: white;
  text-align: center;
}

.social-header {
  text-align: center;
  margin-bottom: var(--space-12);
}

.social-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: var(--space-8);
  max-width: 1200px;
  margin: 0 auto;
}

.social-card {
  background: white;
  border-radius: 16px;
  padding: var(--space-2);
  text-align: left;
  position: relative;
  border: none;
  box-shadow: 12px 12px 0px #F9A619; 
  transition: transform 0.2s ease;
}

.social-card:hover {
  transform: translate(-4px, -4px);
  box-shadow: 16px 16px 0px #F9A619;
}

.social-icons {
  display: flex;
  gap: var(--space-3);
  margin-bottom: var(--space-4);
}

.social-icon svg {
  width: 24px;
  height: 24px;
}

.social-icon.instagram {
  color: #E4405F;
  background: transparent;
}

.social-icon.tiktok {
  color: #000000;
  background: transparent;
}

.social-handle {
  font-size: 24px;
  font-weight: 800;
  color: #1A1A1A;
  margin: 0 0 var(--space-2) 0;
}

.social-desc {
  font-size: 16px;
  line-height: 1.6;
  color: #666666;
  margin: 0;
}

/* Merchandise Section (UPDATED) */
.merchandise-section {
  padding: var(--space-20) 0;
  background: #F5F5F5;
}

.merchandise-header-content {
  display: flex;
  justify-content: center;
  margin-bottom: var(--space-8);
}

.merchandise-title-section {
  text-align: center;
}

.merchandise-wrapper {
  position: relative;
  padding: 0 var(--space-4); 
}

.merchandise-slider-container {
  overflow: hidden;
  width: 100%;
  padding: var(--space-2) 0; 
}

.merchandise-slider {
  display: flex;
  width: 200%; 
}

.merchandise-item {
  flex: 0 0 16.666%; /* 100% / 6 items (3 visible on desktop) */
  padding: 0 var(--space-3);
  box-sizing: border-box;
}

.carousel-btn {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: var(--yellow-main);
  border: none;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all var(--transition-base);
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
}

.carousel-btn:hover {
  background: var(--yellow-soft);
  transform: translateY(-50%) scale(1.1);
  box-shadow: 0 6px 12px rgba(0,0,0,0.15);
}

.prev-floating {
  left: -24px; 
}

.next-floating {
  right: -24px; 
}

.merchandise-card {
  background: white;
  border-radius: var(--radius-xl);
  padding: var(--space-4);
  box-shadow: var(--shadow-sm);
  transition: all var(--transition-base);
  width: 100%;
}

.merchandise-card:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.merchandise-image {
  margin-bottom: var(--space-3);
}

.merchandise-placeholder {
  width: 100%;
  height: 200px;
  border-radius: var(--radius-lg);
  overflow: hidden;
}

.merchandise-placeholder svg {
  width: 100%;
  height: 100%;
}

.merchandise-info {
  text-align: center;
}

.merchandise-name {
  font-size: var(--text-lg);
  font-weight: var(--font-semibold);
  color: var(--text-dark);
  margin: 0 0 var(--space-2) 0;
}

.merchandise-points {
  font-size: var(--text-base);
  font-weight: var(--font-medium);
  color: var(--yellow-main);
  margin: 0;
}

/* Footer */
.footer-section {
  background: var(--yellow-main);
  color: white;
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: var(--space-16) var(--space-6) var(--space-8) var(--space-6);
}

.footer-content {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: var(--space-12);
  margin-bottom: var(--space-8);
}

.footer-logo-img {
  height: 60px;
  width: auto;
  filter: brightness(0) invert(1);
}

.footer-links {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: var(--space-8);
}

.footer-column-title {
  font-size: var(--text-lg);
  font-weight: var(--font-semibold);
  margin: 0 0 var(--space-4) 0;
  color: white;
}

.footer-link {
  display: block;
  color: rgba(255, 255, 255, 0.9);
  text-decoration: none;
  margin-bottom: var(--space-2);
  transition: color var(--transition-base);
}

.footer-link:hover {
  color: white;
}

.footer-contact {
  display: flex;
  gap: var(--space-3);
}

.contact-item {
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  text-decoration: none;
  transition: background var(--transition-base);
}

.contact-item:hover {
  background: rgba(255, 255, 255, 0.3);
}

.footer-address {
  font-size: var(--text-sm);
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.9);
  margin: 0;
}

.footer-bottom {
  text-align: center;
  padding-top: var(--space-8);
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  color: rgba(255, 255, 255, 0.8);
}

/* Section Styles */
.section-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 var(--space-6);
}

.section-header {
  text-align: center;
  margin-bottom: var(--space-12);
}

.section-title {
  font-size: var(--text-5xl);
  font-weight: var(--font-bold);
  color: var(--neutral-800);
  margin: 0 0 var(--space-4) 0;
}

.section-subtitle {
  font-size: var(--text-lg);
  color: var(--neutral-600);
  margin: 0;
}

/* Utility Classes for Responsive Visibility */
.hide-mobile {
  display: block;
}

.hide-desktop {
  display: none;
}

.show-mobile {
  display: none;
}

.show-desktop {
  display: block;
}

/* Responsive Design */
@media (max-width: 768px) {
  .hide-mobile {
    display: none;
  }
  
  .hide-desktop {
    display: block;
  }
  
  .show-mobile {
    display: block;
  }
  
  .show-desktop {
    display: none;
  }

  .communities-title-section .section-title {
    text-align: center;
  }

  .hero-container {
    grid-template-columns: 1fr;
    text-align: center;
    gap: var(--space-6);
    padding: 0 var(--space-4);
    max-width: 100vw;
    overflow: hidden;
  }
  
  .hero-title {
    font-size: var(--text-3xl);
    line-height: 1.3;
  }
  
  .hero-phones {
    justify-content: center;
    max-width: 100%;
    overflow: hidden;
    padding: 0 var(--space-2);
  }
  
  .hero-phones .logo-img {
    max-width: 90vw;
    width: 100%;
    height: auto;
    max-height: 250px;
    object-fit: contain;
  }
  
  .phone-mockup {
    width: 140px;
    height: 280px;
  }
  
  .about-content {
    grid-template-columns: 1fr;
    gap: var(--space-6);
    text-align: center;
    padding: 0 var(--space-4);
  }
  
  .about-title {
    font-size: var(--text-3xl);
  }
  
  .communities-content {
    flex-direction: column;
    gap: var(--space-6);
    text-align: center;
  }
  
  .communities-logos {
    justify-content: center;
    flex-wrap: wrap;
    gap: var(--space-4);
  }
  
  .community-logo-item {
    min-width: 120px;
    min-height: 70px;
  }
  
  .benefits-content {
    grid-template-columns: 1fr;
    gap: var(--space-8);
  }
  
  .benefits-grid {
    grid-template-columns: 1fr;
    gap: var(--space-6);
  }
  
  .benefit-item {
    flex-direction: row;
    text-align: left;
    gap: var(--space-3);
  }
  
  .how-to-content {
    grid-template-columns: 1fr;
    gap: var(--space-8);
    text-align: center;
  }
  
  .mockup-container {
    order: -1; /* Show image first on mobile */
  }
  
  .mockup-image {
    max-width: 90vw;
    height: auto;
  }
  
  .phone-mockup-large {
    width: 250px;
    height: 500px;
    margin: 0 auto;
  }
  
  .how-to-title {
    font-size: var(--text-2xl);
    text-align: center;
  }
  
  .steps-list {
    gap: var(--space-4);
  }
  
  .step-item {
    flex-direction: row;
    text-align: left;
    gap: var(--space-3);
  }
  
  .cta-container {
    flex-direction: column;
    gap: var(--space-4);
    text-align: center;
  }
  
  .cta-title {
    font-size: var(--text-xl);
  }
  
  .testimonials-section {
    padding: var(--space-12) 0;
  }
  
  .testimonials-header {
    flex-direction: column;
    gap: var(--space-4);
    text-align: center;
    margin-bottom: var(--space-8);
  }
  
  .testimonials-title {
    font-size: var(--text-2xl);
  }
  
  .desktop-nav {
    display: none;
  }
  
  .mobile-nav {
    display: flex;
    justify-content: center;
    margin-top: var(--space-6);
  }
  
  .testimonials-grid {
    display: flex;
    justify-content: center;
  }
  
  .testimonial-card {
    width: 100%;
    max-width: 350px;
    margin: 0 auto;
    border: 3px solid var(--yellow-main);
    border-radius: var(--radius-xl);
  }
  
  .social-grid {
    grid-template-columns: 1fr;
    gap: var(--space-4);
  }
  
  .social-title {
    font-size: var(--text-2xl);
  }
  
  .merchandise-section {
    padding: var(--space-12) 0;
  }
  
  .merchandise-header-content {
    flex-direction: column;
    gap: var(--space-4);
    text-align: center;
    align-items: center;
  }
  
  .merchandise-title-section {
    text-align: center;
  }
  
  .merchandise-item {
    flex: 0 0 50%; /* 100% / 2 items (1 visible on mobile) */
  }
  
  .merchandise-card {
    max-width: 300px;
    margin: 0 auto;
  }
  
  .section-container {
    padding: 0 var(--space-4);
  }
  
  .section-title {
    font-size: var(--text-2xl);
  }
  
  /* Mobile adjustments for floating buttons */
  .prev-floating {
    left: 0;
  }
  
  .next-floating {
    right: 0;
  }
  
  .carousel-btn {
    width: 40px;
    height: 40px;
    opacity: 0.9;
  }
}
</style>